export const environment = {
  production: false,
  functionsBaseUrl:
    'https://us-central1-ptg-platform-marketing-site.cloudfunctions.net/',
};
